<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 105 105" :class="{'yellow': iconColour == 'yellow'}">
        <path d="M52.23,104.68A52.18,52.18,0,1,1,104.42,52.5,52.24,52.24,0,0,1,52.23,104.68Zm0-100.76A48.58,48.58,0,1,0,100.82,52.5,48.63,48.63,0,0,0,52.23,3.92Z"/>
        <path d="M79.72,54.3h-55a1.8,1.8,0,0,1,0-3.6h55a1.8,1.8,0,0,1,0,3.6Z"/>
    </svg>
</template>

<style lang="scss" scoped>
    path {
        fill: $colour__primary1;
        .yellow & {
            fill: $colour__accent1;
        }
    }
</style>

<script>
export default {
    name: 'MinusCircleIcon',
    props: ['iconColour']
}
</script>
